import React, { useCallback, useRef } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../commonDesign/SydModal'
import { actionPipelines } from '../../../../api/coreData'
import Loading from '../../../molecules/Loading'
import FadeIn from '../../../molecules/Transitions/FadeIn'
import ErrorDisplay from '../../../molecules/ErrorDisplay'
import DynamicActionForm from '../form/DynamicActionForm'
import { useDenaliActions } from './DenaliActionProvider'

const DenaliActionDialog = ({ size, position, defaultTitle }) => {
  const formRef = useRef(null)
  const { close, dialogState } = useDenaliActions()
  const { data, isLoading, error: loadError } = actionPipelines.useActionTemplate(dialogState?.code)

  // Get mutation hook for executing action pipeline
  const executeActionMutation = actionPipelines.useExecuteActionPipeline()

  const actionTemplate = data
  const error = loadError

  const handleSubmit = useCallback(async (args) => {
    // Execute action pipeline with built args
    // Use actionPipelineCode from definition, not the template code
    await executeActionMutation.mutateAsync({
      code: data?.definition?.actionPipelineCode,
      args,
      invalidations: actionTemplate?.definition?.invalidations
    })

    // Close dialog on success
    close()
  }, [data?.definition?.actionPipelineCode, executeActionMutation, close, actionTemplate])

  return (
    <SydModal
      title={actionTemplate?.name ?? defaultTitle}
      subtitle={actionTemplate?.description}
      open={dialogState?.open}
      onClose={(e) => formRef?.cancel?.(e) ?? close(e)}
      position={position}
      size={size}
      disablePortal={false}
    >
      <FadeIn key={`DenaliActionDialog_${dialogState?.code || 'empty'}`}>
        {error ? (
          <ErrorDisplay error={error} />
        ) : isLoading ? (
          <Loading />
        ) : actionTemplate ? (
          <DynamicActionForm
            ref={formRef}
            actionTemplate={actionTemplate}
            onSubmit={handleSubmit}
            onCancel={close}
            subject={dialogState?.subject}
            variables={dialogState?.variables}
          />
        ) : null}
      </FadeIn>
    </SydModal>
  )
}

DenaliActionDialog.propTypes = {
  size: PropTypes.string,
  position: PropTypes.string,
  defaultTitle: PropTypes.string
}

DenaliActionDialog.defaultProps = {
  defaultTitle: ''
}

export default DenaliActionDialog
